import React from "react";
import { Table, TableBody, TableCell, TableContainer, TableRow } from "@material-ui/core";
import "./IncidentSidebar.scss";

const IncidentDetails = ({ incidentData, diff }) => (
  <TableContainer>
    <Table size="small">
      <TableBody>
        <TableRow>
          <TableCell className="inc-tbl-cell" component="th" scope="row">
            Incident ID
          </TableCell>
          <TableCell className="inc-tbl-cell">
            {incidentData["IncidentsTable.incidentId"]}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell className="inc-tbl-cell" component="th" scope="row">
            Ticket ID
          </TableCell>
          <TableCell className="inc-tbl-cell">
            {incidentData["IncidentsTable.jiraTicketId"]
              ? incidentData["IncidentsTable.jiraTicketId"].replace(
                  /^[A-Za-z]+-/,
                  ""
                ) || "-"
              : "-"}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell className="inc-tbl-cell" component="th" scope="row">
            Creation Time
          </TableCell>
          <TableCell className="inc-tbl-cell">
            {incidentData["IncidentsTable.incidentTime"]
              ? new Date(
                  parseInt(incidentData["IncidentsTable.incidentTime"]) +
                  diff * 60 * 1000
                ).toLocaleString()
              : "-"}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell className="inc-tbl-cell" component="th" scope="row">
            Priority
          </TableCell>
          <TableCell className="inc-tbl-cell">
            <span
              className={
                incidentData["IncidentsTable.priority"] &&
                `mdrIncidentTableSeverityColumn ${incidentData[
                  "IncidentsTable.priority"
                ].toLowerCase()}`
              }
            >
              {incidentData["IncidentsTable.priority"]}
            </span>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell className="inc-tbl-cell" component="th" scope="row">
            State
          </TableCell>
          <TableCell className="inc-tbl-cell">
            {incidentData["IncidentsTable.status"] || "-"}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell className="inc-tbl-cell" component="th" scope="row">
            State Details
          </TableCell>
          <TableCell className="inc-tbl-cell">
            {incidentData["IncidentsTable.stateDetails"] || "-"}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell className="inc-tbl-cell" component="th" scope="row">
            Description
          </TableCell>
          <TableCell className="inc-tbl-cell">
            {incidentData["IncidentsTable.name"] || "-"}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell className="inc-tbl-cell" component="th" scope="row">
            Resolved
          </TableCell>
          <TableCell className="inc-tbl-cell">
            {typeof incidentData["IncidentsTable.resolved"] ===
              "boolean" && incidentData["IncidentsTable.resolved"]
              ? "true"
              : typeof incidentData["IncidentsTable.resolved"] ===
                "boolean" &&
                !incidentData["IncidentsTable.resolved"]
                ? "false"
                : ""}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell className="inc-tbl-cell" component="th" scope="row">
            City
          </TableCell>
          <TableCell className="inc-tbl-cell">
            {incidentData["IncidentsTable.city"] || "-"}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell className="inc-tbl-cell" component="th" scope="row">
            Assignee
          </TableCell>
          <TableCell className="inc-tbl-cell">
            {incidentData["IncidentsTable.assignee"] || "-"}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  </TableContainer>
);

export default IncidentDetails;
